// @ts-nocheck
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import * as React from "react";
import { css } from "styled-components";
import ProductIcons from "@store/Library/Components/ProductIcons/ProductIcons";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsProductIconsStyles {
    container?: GridContainerProps;
}

export const productIconsStyles: ProductDetailsProductIconsStyles = {
    container: {
        gap: 0,
    },
};

const styles = productIconsStyles;

const ProductDetailsProductIcons: React.FC<Props> = ({ product }) => {
    if (!product) {
        return null;
    }

    return (
        <GridContainer {...styles.container}>
            <ProductIcons product={product} />
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsProductIcons),
    definition: {
        displayName: "Product Icons",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
